import { render, staticRenderFns } from "./MarkupImage.vue?vue&type=template&id=773cd7a2&scoped=true&"
import script from "./MarkupImage.vue?vue&type=script&lang=js&"
export * from "./MarkupImage.vue?vue&type=script&lang=js&"
import style0 from "./MarkupImage.vue?vue&type=style&index=0&id=773cd7a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773cd7a2",
  null
  
)

export default component.exports